/*globals $ */
'use strict';
import once from 'lodash/once';

const gridCardlist = {
  /**
   * Init engine. Wrapped in lodash once to make sure it's not called repeatedly
   */
  init: once(() => {
    gridCardlist.initDivList();
  }),
  /**
   * Init for binding events
   */
  initDivList: () => {
    const list = document.querySelectorAll('.grid-card.clickable');
    if(list)
      list.forEach(element => {
        element.addEventListener('click',
          (e, link = element.querySelector('a')) => {
            e.preventDefault();
            window.location = link;
          })
      });
  },
};

export default gridCardlist;
